const basePath = "https://canva-smarttv.pages.dev/"; //import.meta.env.BASE_URL;

export default [
  {
    type: "msdf",
    fontFamily: "Roboto",
    descriptors: {
      weight: 700,
    },
    atlasDataUrl: basePath + "fonts/Roboto-Bold.msdf.json",
    atlasUrl: basePath + "fonts/Roboto-Bold.msdf.png",
  } as const,
  {
    type: "msdf",
    fontFamily: "Roboto",
    descriptors: {
      weight: 400,
    },
    atlasDataUrl: basePath + "fonts/Roboto-Regular.msdf.json",
    atlasUrl: basePath + "fonts/Roboto-Regular.msdf.png",
  } as const,
  {
    type: "msdf",
    fontFamily: "Arial",
    descriptors: {
      weight: 500,
    },
    atlasDataUrl: basePath + "fonts/Roboto-Regular.msdf.json",
    atlasUrl: basePath + "fonts/Roboto-Regular.msdf.png",
  } as const,

  // Web fonts for the Canvas2D renderer fallback (SDF fonts above are WebGL
  // only and are skipped there). Relative URLs so they resolve next to
  // index.html, also when hosted under a sub-folder like /april2026/.
  {
    fontFamily: "Roboto",
    descriptors: { weight: 700 },
    fontUrl: "./fonts/NotoSans-Bold.ttf",
  },
  {
    fontFamily: "Roboto",
    descriptors: { weight: 400 },
    fontUrl: "./fonts/NotoSans-Regular.ttf",
  },
  {
    fontFamily: "Arial",
    descriptors: { weight: 500 },
    fontUrl: "./fonts/NotoSans-Regular.ttf",
  },
];
